import { danger, infoGreen } from '../../assets/images/dashboard-business';
import { Link } from 'react-router-dom';
import Button2 from '../global/Button2';

type CompletePaymentCardProps = {
  className?: string;
};

const CompletePaymentCard = ({ className }: CompletePaymentCardProps) => {
  return (
    <>
      <div
        style={{
          border: '0.2px solid #028789',
          borderRadius: '20px',
          boxShadow: '0px 16.52px 30px rgba(118, 131, 150, 0.09)',
        }}
        className={`py-4 mb-[30px] mt-[20px] px-[20px] lg:w-[94%] ${className} lg:flex lg:gap-4 justify-between items-center flew-wrap`}
      >
        <div className='flex gap-2 items-center'>
          <img src={infoGreen} alt='' className='w-[50px] !hidden lg:!block' />
          <div>
            <div className='flex gap-2 items-center'>
              <img src={infoGreen} alt='' className='w-[50px] lg:!hidden' />
              <h2 className='font-bold text-[16px] lg:text-lg text-[#028789] font-poppins mb-2'>
                {`View your business registrations status here`}
              </h2>
            </div>
            <p className='text-[11px] mt-2 lg:mt-0 lg:text-xs font-poppins text-black font-normal '>
              {`Uncompleted business registrations can be continued and are valid only for a period of 15 days from the day it started.`}
              <br />{' '}
              {`We encourage you to complete and pay for them before then or you might not be able to continue.`}
            </p>
          </div>
        </div>
        <div className='flex sm:mt-[10px] items-end mb-1 mt-3'>
          <Link to='/my-business?active=2'>
            <Button2
              theme='tertiary'
              className=' !py-2 rounded-[8px] cursor-pointer text-[10px] lg:text-xs'
              size='xs'
            >
              {'VIEW STATUS'}
            </Button2>
          </Link>
        </div>
      </div>

      {/* <PendingBusinessRegModal
        show={show}
        setShow={setShow}
        setShowPayment={setShowPayment}
        pendingPackages={pendingPackages}
        setAmount={setAmount}
      />
      <PaymentModal show={showPayment} setShow={setShowPayment} amount={amount} /> */}
    </>
  );
};

export default CompletePaymentCard;
